import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WebStorageService {
  constructor(@Inject(PLATFORM_ID) private platformId: object) { }

  get(item: string) {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem(item);
    }

    return null;
  }

  set(item: string, value) {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(item, value);
    }
  }

  remove(item: string) {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem(item);
    }
  }
}
